module.exports = __webpack_public_path__ + "img/google-stadia-05.a1ee9ca1.webp";